import { MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { Handle, Position } from "@xyflow/react";
import HandlePoint from "./Handle";


function CFNodeUI(props) {
  console.log("--------------------------------------------------");
  console.log(props.targethandles);
  const [handles, setHandles] = useState(props.targethandles);
  if (!Array.isArray(handles)) {
    setHandles([]);
  }
  if (!props.data) {
    props.data = {};
  }
  const onDelete = () => {
    props.onDelete(props.data.id);
  };

  const deleteHandle = (id) => {
    let afterDelList = handles.filter((hd) => hd.id != id);
    setHandles(afterDelList);
    props.onHandleDelete(afterDelList);
  };
  const updateHandle = (tvalue, id) => {
    props.onHandleUpdate(tvalue, id);
  };

  useEffect(() => {
    setHandles(props.targethandles);
  }, [props.targethandles]);
  return (
    <>
      <div key={props.data.id}>
        <div className={props.headerClass}>
          {props.data.label}
          {props.deletable && (
            <>
              <MDBIcon
                fas
                icon="times"
                className="cursor-pointer"
                color="light"
                onClick={() => onDelete()}
              />
            </>
          )}
        </div>
        <div className="nodeBody">
          <>{props.bodyContnent}</>
        </div>
        {props.targetNode && (
          <>
            <Handle
              type="target"
              key={props.targetNode}
              position={Position.Left}
              id="target"
            ></Handle>
          </>
        )}
        <React.Fragment key={props.data.id}>
          {handles && (Array.isArray(handles)) &&
            handles.map((handle, index) => (
              <>
                <React.Fragment key={handle.id || index}>
                  <HandlePoint
                    oerr={props.oerr ? props.oerr[index] : ""}
                    key={index}
                    node={handle.ctNode}
                    value={handle.value}
                    onDel={deleteHandle}
                    onUpdate={updateHandle}
                    isselect={handle.isselect}
                    id={`${handle.id || index}`}
                    label={handle.name}
                    handleId={handle.id}
                    top={(handle.top ? handle.top * 1 : 130) + index * 20}
                    visible={true}
                    deletable={handle.deletable}
                    handleClass={handle.class ? handle.class : "handletext"}
                  />
                </React.Fragment>
              </>
            ))}
        </React.Fragment>
      </div>
    </>
  );
}

export default CFNodeUI;
